import { MakeCall } from './createMakeCall';

const deletePaymentMethod =
  (makeCall: MakeCall) => (userId: number, paymentMethodId: number) =>
    makeCall<undefined>(
      'DELETE',
      `/api/v2/user/${userId}/payment-method/${paymentMethodId}`,
    );
export { deletePaymentMethod };
